import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import {
  AdvertisingCampaignInterface
} from 'src/app/shared/models/advertising-campaigns/advertising-campaign.interface';
import {
  SelectedLps
} from 'src/app/shared/models/location-partners/selectedLps';
import {
  getAdCompaignByHashedIdSelector
} from 'src/app/store/advertisingCampaign/advertiserCampaign.selectors';
import { AppStateInterface } from 'src/app/store/appState.interface';
import {
  selectedLPs
} from 'src/app/store/locationPartner/location-partner.action';
import {
  saveSelectedLPsSelector
} from 'src/app/store/locationPartner/location-partner.selectors';

@Component({
  selector: 'app-ads-locations',
  templateUrl: './ads-locations.component.html',
  styleUrls:   ['./ads-locations.component.scss']
})
export class AdsLocationsComponent implements OnInit {
  locations: string[] = [];
  selectedLocations: string[] = [];

  private subs = new Subscription();

  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    // load previously-saved selection
    this.subs.add(
      this.store.select(saveSelectedLPsSelector).subscribe((data) => {
        if (data && data.companyNames?.length) {
          this.selectedLocations = [...data.companyNames];
        } else {
          this.selectedLocations = [];
        }
      })
    );

    // load list of all possible locations
    this.subs.add(
      this.store
        .select(getAdCompaignByHashedIdSelector)
        .subscribe((campaign) => {
          if (campaign) {
            this.locations = [...campaign.locationPartners];
          }
        })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onToggleAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedLocations = checked ? [...this.locations] : [];
  }

  onToggleLocation(event: Event, location: string) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      if (!this.selectedLocations.includes(location)) {
        this.selectedLocations.push(location);
      }
    } else {
      this.selectedLocations = this.selectedLocations.filter(l => l !== location);
    }
  }

  submitLocation() {
    this.store.dispatch(
      selectedLPs({
        selectedLps: {
          companyNames: this.selectedLocations,
          isCalculator: false,
          count: this.selectedLocations.length
        }
      })
    );
    this.modalService.dismissAll();
  }

  onClickDismissModal() {
    this.modalService.dismissAll();
  }
}
